/* eslint-disable */
export function numericInputHandlers(state, setState) {
  const parseNumeric = (v) => {
    if (v === '') return '0';
    if (/^\d+$/.test(v)) return String(parseInt(v, 10));
    return null;
  };

  return {
    onChange: (field) => (e) => {
      const val = parseNumeric(e.target.value);
      if (val !== null) {
        setState({ ...state, [field]: val });
      }
    },

    onBlur: (field) => () => {
      const value = state[field];
      if (!value || Number.isNaN(Number(value))) {
        setState({ ...state, [field]: '0' });
      }
    },
  };
}
